export const MIN_Y = 106; // 바텀시트가 최대로 높이 올라갔을 때의 y 값 (상단에서부터)
export const MIN_SHEET_VISIBLE_HEIGHT = 220; // 접혔을 때 최소로 보이는 높이(px)
export const MAX_Y = Math.max(MIN_Y + 100, window.innerHeight - MIN_SHEET_VISIBLE_HEIGHT); // 바텀시트가 최소로 내려갔을 때의 y 값
export const BOTTOM_SHEET_HEIGHT = window.innerHeight - MIN_Y; // 바텀시트의 세로 길이
